module.exports = __webpack_public_path__ + "media/neworderTZ.6d8d8f22.mp3";